export default "__VITE_ASSET__Cdk_tt8J__"